import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

interface IResource {
  [key: string]: any
}

class Resource extends Model<IResource> {
  constructor(attr: IResource = {}) {
    super(attr)
    makeObservable(this, {
      isValid: computed,
      isActive: computed,
    })
  }

  async upsert() {
    if (this.isNew) {
      return this.save()
    }

    if (!this.hasChanges()) {
      return Promise.resolve()
    }

    return this.archive()
  }

  async archive() {
    const result = await this.rpc('archive', {
      archived: this.attributes.archived,
    })
    this.set(result)
    this.commitChanges()
  }

  get isValid(): boolean {
    return this.attributes.name !== ''
  }

  get isActive(): boolean {
    return !this.attributes.archived
  }
}

export default Resource
